export const TV_TRAFFIC_IDS = [13, 14];
